import React, { useState } from "react";
import {
    Button,
    Input,
    Space,
  } from 'antd';

const WscInput = ({value,size,onChange}) => {
    const [val,setVal] = useState(value);
   return (<Space.Compact>
    <Input style={{
          width: 'calc(100% - 50px)',
        }} size={size} value={val} onChange={e=>setVal(e.target.value)} />
    <Button disabled={val==value} size={size} type="primary" onClick={()=>{
        onChange(val);
    }}>√</Button>
    <Button disabled={val==value} size={size} onClick={()=>{
        setVal(value);
    }} >×</Button>
  </Space.Compact>);
}

export default WscInput;